﻿import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from '../components/Loadable';
import DashboardLayout from '../layout/Dashboard';
import ProtectedRoute from '../components/ProtectedRoute';

// render- Spectra
const SpectraDefault = Loadable(lazy(() => import('../pages/spectra/spectraviewer')));
const SpectraEquipments = Loadable(lazy(() => import('../pages/spectra/equipments')));
const AnalyticsDashboards = Loadable(lazy(() => import('../pages/analytics/dashboards')));
const AnalyticsResults = Loadable(lazy(() => import('../pages/analytics/results')));
const SupportHelpCenter = Loadable(lazy(() => import('../pages/support/helpcenter')));


// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = [
  {
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: '/spectra',
        children: [
          { index: true, element: <Navigate to="/spectra/spectraviewer" replace /> },
          { path: 'spectraviewer', element: <SpectraDefault /> },
          { path: 'equipments', element: <SpectraEquipments /> }
        ]
      },
      {
        path: '/analytics',
        children: [
          { path: 'dashboards', element: <AnalyticsDashboards /> },
          { path: 'results', element: <AnalyticsResults /> }
        ]
      },
      {
        path: '/support',
        children: [
          { path: 'helpcenter', element: <SupportHelpCenter /> }
        ]
      }
    ]
  }
];

export default MainRoutes;

